declare let lexicon: Record<string, string>;

export const i18n = {
    lexicon,

    /**
     * return a translation from a lexicon string
     * @param id - e.g. login.error
     * @param subs - substitutes
     */
    t(id: string, ...subs: string[]): string {
        if (typeof id.split === 'undefined') return `%${id}%`;
        const split = id.split('.');
        const category = split.shift();
        const key = split.join('.');

        if (typeof this.lexicon !== 'undefined') {
            if (typeof this.lexicon[category] !== 'undefined' && typeof this.lexicon[category][key] !== 'undefined') {
                if (typeof subs !== 'undefined' && subs !== null) {
                    return this.sprintf(this.lexicon[category][key], ...subs);
                }
                return this.lexicon[category][key];
            }
        }

        console.warn(`i18n: no translation for %${id}% (${window.lang})`);
        return `%${id}%`;
    },

    /**
     * check if translation exists
     */
    has_translation(id: string): boolean {
        return (this.t(id) !== `%${id}%`);
    },

    /**
     * sprintf substitute
     */
    sprintf(text: string, ...subs: string[]): string {
        let counter = 0;

        return text.replace(/%s/g, () => subs[counter++]);
    },
};
